var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bl_input" }, [
    !_vm.data.answered
      ? _c("div", [
          _c(
            "div",
            { staticClass: "question" },
            [
              _c("div", { staticClass: "title" }, [
                _c("strong", { staticClass: "bold" }, [
                  (_vm.data.rule
                  ? _vm.data.rule.isNecessary
                    ? 1
                    : 0
                  : 0)
                    ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.data.questionTitle))
                ]),
                _vm._v(" "),
                (_vm.data.rule
                ? _vm.data.rule.subTitle
                : false)
                  ? _c("span", { staticClass: "span" }, [
                      _vm._v(_vm._s(_vm.data.rule.subTitle))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.data.questionDes ? JSON.parse(_vm.data.questionDes) : [],
                function(o) {
                  return _c("div", {
                    key: JSON.stringify(o),
                    staticClass: "text",
                    domProps: { textContent: _vm._s(o.txt) }
                  })
                }
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "answer" },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.data.rule
                    ? _vm.data.rule.placeholder
                      ? _vm.data.rule.placeholder
                      : "请输入内容"
                    : "请输入内容"
                },
                model: {
                  value: _vm.input,
                  callback: function($$v) {
                    _vm.input = $$v
                  },
                  expression: "input"
                }
              })
            ],
            1
          )
        ])
      : _c("div", [
          _c(
            "div",
            { staticClass: "question" },
            [
              _c("div", { staticClass: "title" }, [
                _c("strong", { staticClass: "bold" }, [
                  (_vm.data.rule
                  ? _vm.data.rule.isNecessary
                    ? 1
                    : 0
                  : 0)
                    ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.data.questionTitle))
                ]),
                _vm._v(" "),
                (_vm.data.rule
                ? _vm.data.rule.subTitle
                : false)
                  ? _c("span", { staticClass: "span" }, [
                      _vm._v(_vm._s(_vm.data.rule.subTitle))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.data.questionDes ? JSON.parse(_vm.data.questionDes) : [],
                function(o) {
                  return _c("div", {
                    key: JSON.stringify(o),
                    staticClass: "text",
                    domProps: { textContent: _vm._s(o.txt) }
                  })
                }
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "answer" },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.disabledBol,
                  placeholder: _vm.data.rule
                    ? _vm.data.rule.placeholder
                      ? _vm.data.rule.placeholder
                      : "请输入内容"
                    : "请输入内容"
                },
                model: {
                  value: _vm.input,
                  callback: function($$v) {
                    _vm.input = $$v
                  },
                  expression: "input"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.otherBol
            ? _c(
                "div",
                { staticClass: "other" },
                [
                  _c("div", { staticClass: "other_title" }, [
                    _vm._v("其它答案："),
                    _vm.otherList.length
                      ? _c(
                          "span",
                          {
                            staticClass: "cursor",
                            on: { click: _vm.getChange }
                          },
                          [_vm._v("换一换")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.otherList, function(i) {
                    return _c(
                      "div",
                      { key: i.examQuestionId, staticClass: "other_item" },
                      [_vm._v("· " + _vm._s(i.answer) + "。")]
                    )
                  }),
                  _vm._v(" "),
                  !_vm.otherList.length
                    ? _c("div", { staticClass: "other_item_no" }, [
                        _vm._v("\n        还没有其它哦~\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "other_border" })
                ],
                2
              )
            : _vm._e()
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "answerObj none" }, [
      _vm._v(_vm._s(_vm.answerObj))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "isNecessary none" }, [
      _vm._v(_vm._s(_vm.data.rule ? (_vm.data.rule.isNecessary ? 1 : 0) : 0))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-44d07ea7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-44d07ea7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/topic/public/input.vue
// module id = null
// module chunks = 